import { useSelector } from "react-redux";
import { DatapointFilterOperatorEnum, DatapointIdStandardEnum, DatapointsEntityType } from "api/ux/src";
import { useGetUnitOfAreaKey, useGetUserAllocationKey, useGetUserCommitmentCalculation } from "components/frame/hooks/use-user-preferences";
import { Permissions, usePermission } from "feature-flag";
import { useGetEsgSustainability } from "hooks/use-tenant-settings";
import { buildPipeline } from "hooks/widget-data/datapoints-api/pipeline";
import { allocationKeyEnumValues, commitmentCalculationEnumValues, createId, getDatapointIdFromIdString, unitOfAreaKeyEnumValue, useDatapoints } from "hooks/widget-data/use-datapoints";
import { gridCurrencySelector } from "store/grids";
import { AddInvestorAccountsOrFundsMode } from "store/modal/portfolio-creation-types";
const createFilters = (useFilters, stateFilters, permissionEnabled, groupId) => {
    const filters = useFilters
        ? Object.entries(stateFilters || {}).map(([k, v]) => ({ datapoint: getDatapointIdFromIdString(k),
            operator: DatapointFilterOperatorEnum.In,
            values: v }))
        : [];
    if (permissionEnabled && groupId) {
        filters.push({ datapoint: { standard: DatapointIdStandardEnum.PortfolioUserGroupId }, operator: DatapointFilterOperatorEnum.In, values: [groupId] });
    }
    return filters.length ? filters : undefined;
};
const useCreateDatapointsRequestWithFilters = (dimensions, measures, stateId, useFilters, mode) => {
    const allocationKey = useGetUserAllocationKey(), commitmentCalculation = useGetUserCommitmentCalculation(), currency = useSelector((s) => gridCurrencySelector(s, stateId)), esgSustainability = useGetEsgSustainability(), groupId = useSelector((state) => state.portfolioCreation?.information?.userGroupId), permissionEnabled = usePermission([Permissions.PERMISSIONS]), stateFilterValues = useSelector((state) => state.portfolioCreation?.compositionRules), unitOfArea = useGetUnitOfAreaKey();
    if (!allocationKey || !unitOfArea || !commitmentCalculation) {
        return null;
    }
    const date = new Date();
    date.setUTCHours(0, 0, 0, 0);
    const requestParameters = {
        datapointsRequest: {
            allocationKey: allocationKeyEnumValues(allocationKey),
            asOfDate: date,
            commitmentCalculation: commitmentCalculationEnumValues(commitmentCalculation),
            entityId: "All",
            entityType: DatapointsEntityType.Portfolio,
            esgSustainability,
            filters: createFilters(useFilters, stateFilterValues, permissionEnabled, groupId),
            requests: [{ dimensions, id: `PortfolioCreation_${mode}`, measures }],
            selectedCurrency: currency,
            unitOfArea: unitOfAreaKeyEnumValue(unitOfArea)
        }
    };
    createId(requestParameters.datapointsRequest);
    return requestParameters;
};
export const useGetDatapointsDataWithFilters = (dimensions, measures, stateId, useFilters, mode = AddInvestorAccountsOrFundsMode.Default) => {
    const request = useCreateDatapointsRequestWithFilters(dimensions, measures, stateId, useFilters, mode);
    const [responses, queryState, refresh] = useDatapoints(request);
    let data = [];
    if (responses?.responses) {
        const pipeline = buildPipeline({
            compositeObjectBuilder: {
                dimensions: request?.datapointsRequest?.requests[0]?.dimensions?.map((d) => d.name || "") || [],
                measures: request?.datapointsRequest?.requests[0]?.measures?.map((m) => m.name || "") || []
            }
        });
        if (responses?.responses?.length) {
            const response = responses.responses;
            data = pipeline(response)[0].root ?? [];
        }
    }
    return [data, queryState, refresh];
};
